
    import styled from 'styled-components';
    
    const BackgroundSVG = ({className, width, height, ...props}) =>
        <svg className={className} width={`${width / 2}px`} height={`${height}px`} viewBox={ '0 0 1195 838' } preserveAspectRatio="xMidYMid slice" version="1.1">
            <g id="desktop-homepage" transform="translate(-15.000000, -84.000000)" fill="none">
                <g id="Group-5" transform="translate(694.350509, 129.000000)" stroke="#F1CC02" strokeWidth="2">
                    <path d="M672,185.785361 C672,287.897018 362.99648,505.898104 233.84704,505.898104 C104.69632,505.898104 0,287.897018 0,185.785361 C0,83.6749866 104.69632,0.898104265 233.84704,0.898104265 C362.99648,0.898104265 672,83.6749866 672,185.785361 Z"></path>
                </g>
                <path d="M1094.12635,-83.5798703 C1171.76393,-17.8503237 1260.35339,-44.5199387 1260.35339,57.2828647 C1260.35339,131.970373 1216.62617,256.667923 1161.40889,303.29513 C1141.44319,320.155238 1095.53734,336.483227 1043.35352,349.90044 L1043.35051,-132 C1058.36461,-116.303242 1074.85534,-99.8951011 1094.12635,-83.5798703 Z" stroke="#FF004A" strokeWidth="2" transform="translate(1151.851952, 108.950220) rotate(-270.000000) translate(-1151.851952, -108.950220) "></path>
                <g id="Group-5" transform="translate(1246.276376, 752.397403) rotate(-31.000000) translate(-1246.276376, -752.397403) translate(843.276376, 448.397403)" stroke="#932BAD">
                    <path d="M805.939287,223.114465 C805.939287,345.850654 435.77882,607.883643 281.068553,607.883643 C126.356753,607.883643 0.939286751,345.850654 0.939286751,223.114465 C0.939286751,100.379817 126.356753,0.8836435 281.068553,0.8836435 C435.77882,0.8836435 805.939287,100.379817 805.939287,223.114465 Z"></path>
                </g>
                <g id="Group-5" transform="translate(787.850509, 580.500000) rotate(-123.000000) translate(-787.850509, -580.500000) translate(582.350509, 425.000000)" stroke="#29B1DA">
                    <path d="M410.798341,114.223498 C410.798341,176.905901 222.269407,310.72835 143.472874,310.72835 C64.6755596,310.72835 0.798340507,176.905901 0.798340507,114.223498 C0.798340507,51.541882 64.6755596,0.728350288 143.472874,0.728350288 C222.269407,0.728350288 410.798341,51.541882 410.798341,114.223498 Z"></path>
                </g>
                <g id="Group-5" transform="translate(494.500000, 1212.734420) rotate(-253.000000) translate(-494.500000, -1212.734420) translate(77.000000, 824.234420)" stroke="#30B62C">
                    <path d="M834.797683,284.669294 C834.797683,441.577503 451.302243,776.565311 291.018563,776.565311 C130.733294,776.565311 0.797682785,441.577503 0.797682785,284.669294 C0.797682785,127.763055 130.733294,0.56531074 291.018563,0.56531074 C451.302243,0.56531074 834.797683,127.763055 834.797683,284.669294 Z"></path>
                </g>
            </g>
        </svg>

    export const Background = styled(BackgroundSVG)`
        display: block;
        position: absolute;
        background-color: ${({bgColor}) => bgColor || `transparent`};
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;

        ${({theme}) => theme.breakpoints['sm']}
        {
            
        }
    `;

    export const Content = styled.div`
        display: block;
        position: relative;
    `;

    export const ArrowElement = ({ className, ...props }) =>
        <svg className={className} width="45px" height="44px" viewBox="0 0 45 44" version="1.1">
            <g className="arrowIcon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(0, 0)">
                <circle className="circle" fill="#000000" cx="22.75" cy="21.75" r="21.75"></circle>
                <path className="arrow" d="M22.793212,15.3994631 L32.7478935,21.1042806 C33.2214936,21.3756908 33.2479526,22.0330791 32.8330874,22.3493222 L32.7374349,22.411602 L22.6927563,27.9564246 L21.9678465,26.6432202 L29.506,22.481 L22.3788637,22.4250549 L0.494000192,22.249976 L0.505999808,20.750024 L22.3908634,20.9251029 L29.519,20.982 L22.0473851,16.7009017 L22.793212,15.3994631 Z" fill="#DDF4F6" fillRule="nonzero"></path>
            </g>
        </svg>

    export const IconElement = ({ className, ...props}) =>
        <div></div>
        
